Drupal.behaviors.projectsCarousel = {
  attach(context) {
    once('projects-carousel', '.block-views-blockhero-carousel-block-1', context)
      .forEach((carousel) => {
        const viewContent = carousel.querySelector('.view-content');
        const slides = carousel.querySelectorAll('.carousel-slide');
        let autoplayInterval;

        if (!viewContent || slides.length === 0) return;

        viewContent.classList.add('slide-right');
        slides[0].classList.add('active-slide');

        const nextSlide = () => {
          viewContent.classList.remove('slide-left');
          viewContent.classList.add('slide-right');

          setTimeout(() => {
            const active = carousel.querySelector('.carousel-slide.active-slide');
            const currentIndex = Array.from(slides).indexOf(active);
            const nextIndex = (currentIndex + 1) % slides.length;

            active.classList.add('removing');
            slides[nextIndex].classList.add('active-slide');

            setTimeout(() => {
              active.classList.remove('active-slide', 'removing');
            }, 250);
          }, 250);

          initAutoplay();
        };

        const prevSlide = () => {
          viewContent.classList.remove('slide-right');
          viewContent.classList.add('slide-left');

          setTimeout(() => {
            const active = carousel.querySelector('.carousel-slide.active-slide');
            const currentIndex = Array.from(slides).indexOf(active);
            const prevIndex = (currentIndex - 1 + slides.length) % slides.length;

            active.classList.add('removing');
            slides[prevIndex].classList.add('active-slide');

            setTimeout(() => {
              active.classList.remove('active-slide', 'removing');
            }, 250);
          }, 250);

          initAutoplay();
        };

        const initAutoplay = () => {
          clearInterval(autoplayInterval);
          autoplayInterval = setInterval(nextSlide, 4000);
        };

        carousel.querySelector('.carousel-next.arrow-white')?.addEventListener('click', nextSlide);
        carousel.querySelector('.carousel-prev.arrow-white')?.addEventListener('click', prevSlide);

        carousel.classList.add('carousel-loaded');
        initAutoplay();
      });
  }
};
